import { FormattedMessage } from 'react-intl';
import useGTAG, { GTAGPrefix } from 'src/hooks/useGTAG';
import NextImage from '../../../../shared-components/NextImage/NextImage';
import NavigationLink, {
  Targets
} from '../../../../shared-components/NavigationLink/NavigationLink';
import trns from '../../trns';

const warningIcon = 'drug/warning.svg';
const WarningMessageBlock = () => {
  const { trackGtagEvent } = useGTAG();
  return (
    <div className="bg-milkPunch flex p-6 mb-16 rounded-lg">
      <NextImage
        alt={'warning-icon'}
        src={warningIcon}
        layout="fixed"
        objectFit="contain"
        quality={100}
        height={20}
        width={20}
      />
      <div className="ml-3.5">
        <p className="fs-header6-bold mb-3">
          <FormattedMessage {...trns.payAttention} />
        </p>
        <p className="fs-body-lg-reg">
          <FormattedMessage {...trns.instructionDescription} />
        </p>
        <p>
          <FormattedMessage {...trns.moreDetails} />{' '}
          <NavigationLink
            href="/privacy_policy"
            onClick={() =>
              setTimeout(
                () => trackGtagEvent(`${GTAGPrefix.item}_disclaimer`),
                250
              )
            }
            target={Targets.BLANK}
            passClassName="underline cursor-pointer text-astronautBlue"
          >
            <FormattedMessage {...trns.denialOfResponsibility} />
          </NavigationLink>
        </p>
      </div>
    </div>
  );
};

export default WarningMessageBlock;
